import { render, staticRenderFns } from "./FlipPageButtonComponent.vue?vue&type=template&id=a5e6e2ac&scoped=true&"
import script from "./FlipPageButtonComponent.vue?vue&type=script&lang=js&"
export * from "./FlipPageButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./FlipPageButtonComponent.vue?vue&type=style&index=0&id=a5e6e2ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6e2ac",
  null
  
)

export default component.exports